export const LABELS = {
  DIALOG: {
    DISMISS: ['notifications.dialog.dismiss', 'Close'],
    TITLE: ['notifications.dialog.title', 'Notification'],
  },
};
